import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Injectable()
export class ViewInboundActiveNumberSettingsFormService {

  public form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {
    this.form = fb.group({
      user: null,
      authUser: null,
      secret: null,
      host: null,
      port: null,
      extension: null,
      telephoneNumber: null,
      //additionalInfo: null,
      //stasisApp: null,
      provider:null,
      internalNumber:[null, Validators.required],
    });
  }

  getControlName(controleName: string): UntypedFormControl {
    return this.form.get(controleName) as UntypedFormControl;
  }

  makeAllFieldsRequired() {
    Object.keys(this.form.controls).map(key => {
      if (key != "provider") {
        var control = this.form.get(key);
        control.setValidators(Validators.required);
        control.updateValueAndValidity();
      }
    })
  }

  removeFieldsRequired() {
    Object.keys(this.form.controls).map(key => {
      var control = this.form.get(key);
      if (key != "provider") {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    })
  }

  createSerializedConnectionSettings(): string {
    const data = this.form.value;

    let connectionSettings: any = {
      User: data.user,
      AuthUser: data.authUser,
      Secret: data.secret,
      Host: data.host,
      Port: data.port,
      Extension: data.extension,
      TelephoneNumber: data.telephoneNumber,
      AdditionalInfo: data.additionalInfo,
      StasisApp: data.stasisApp
    };

    const serializedObj: string = JSON.stringify(connectionSettings);
    return serializedObj;
  }

}
